/* ---- FULL SCREEN PLAY + THE WAY BACK TO THE FLOOR ---- */
(function(){
  var play = document.getElementById('play'); if (!play) return;
  var MIND = ['recall','count','color','math','pattern','nback'];
  var gid = window.STATION_GAME_ID || '';
  var hub = MIND.indexOf(gid) > -1 ? '/pages/mind-bay' : '/pages/arcade';
  var hubName = MIND.indexOf(gid) > -1 ? 'THE MIND BAY' : 'THE FLOOR';
  var host = play.querySelector('.m-top') || document.querySelector('.row'); if (!host) return;

  var back = document.createElement('a');
  back.className = 'fs-btn'; back.href = hub; back.textContent = '\u2190 ' + hubName;
  back.style.textDecoration = 'none';
  host.appendChild(back);

  var btn = document.createElement('button');
  btn.className = 'fs-btn'; btn.id = 'fsBtn'; btn.type = 'button'; btn.textContent = 'FULL SCREEN';
  host.appendChild(btn);

  /* an exit that is always reachable while the machine owns the screen */
  var exit = document.createElement('a');
  exit.id = 'fsExit'; exit.href = hub; exit.textContent = '\u2715  EXIT TO ' + hubName;
  exit.style.cssText = 'position:fixed;top:max(14px,env(safe-area-inset-top));right:14px;z-index:10000;display:none;'
    + 'font-family:\'IBM Plex Mono\',monospace;font-size:11px;letter-spacing:.14em;text-decoration:none;'
    + 'padding:11px 15px;border-radius:999px;border:1px solid #F0C75E;color:#F0C75E;background:rgba(5,7,12,.86)';
  document.body.appendChild(exit);

  /* The machine lives inside a wrap whose own stacking context traps it — a fixed
     child cannot rise above a LATER section no matter how high its z-index goes.
     So for the duration of full screen we lift the machine out to <body> and put
     it back afterwards, with a placeholder holding its spot in the page. */
  var home = null, mark = null;
  function lift(){
    if (home) return;
    home = play.parentNode;
    mark = document.createComment('play');
    home.insertBefore(mark, play);
    document.body.appendChild(play);
  }
  function drop(){
    if (!home || !mark) return;
    home.insertBefore(play, mark);
    mark.parentNode.removeChild(mark);
    home = mark = null;
  }
  function on(){ lift(); document.body.classList.add('fs-on'); document.documentElement.classList.add('fs-on');
    btn.textContent = 'EXIT FULL SCREEN'; exit.style.display = 'block'; dispatchEvent(new Event('resize')); }
  function off(){ document.body.classList.remove('fs-on'); document.documentElement.classList.remove('fs-on');
    drop(); btn.textContent = 'FULL SCREEN'; exit.style.display = 'none'; dispatchEvent(new Event('resize')); }
  function toggle(){ document.body.classList.contains('fs-on') ? off() : on(); }
  btn.addEventListener('click', toggle);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && document.body.classList.contains('fs-on')) off(); });
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('#playBtn,[data-play],[data-daily]');
    if (t) setTimeout(function(){ if (!document.body.classList.contains('fs-on')) on(); }, 80);
    var x = e.target.closest && e.target.closest('#mClose,#exitBtn');
    if (x && document.body.classList.contains('fs-on')) off();
  });
})();
